/** Keep the displayed selection and the native multipart input in sync. */
export default function fileField() {
    let selected = [];
    let input;
    let form;
    let onReset;

    return {
        enhanced: false,
        files: [],
        message: '',

        init() {
            input = this.$refs.input;
            try {
                const transfer = new DataTransfer();
                for (const file of input.files) transfer.items.add(file);
                input.files = transfer.files;
            } catch {
                return;
            }
            selected = Array.from(input.files);
            this.sync();
            this.enhanced = true;
            form = input.form;
            onReset = (event) => {
                queueMicrotask(() => {
                    if (event.defaultPrevented) return;
                    selected = [];
                    this.message = '';
                    this.sync();
                });
            };
            form?.addEventListener('reset', onReset);
        },

        choose() {
            if (this.enhanced) this.add(Array.from(input.files));
        },

        dragOver(event) {
            if (!this.enhanced || !Array.from(event.dataTransfer.types).includes('Files')) return;
            event.preventDefault();
            event.dataTransfer.dropEffect = 'copy';
        },

        drop(event) {
            if (!this.enhanced || !Array.from(event.dataTransfer.types).includes('Files')) return;
            event.preventDefault();
            this.add(Array.from(event.dataTransfer.files));
        },

        add(incoming) {
            if (!incoming.length) return;
            const next = input.multiple ? [...selected] : [];
            for (const file of incoming) {
                if (!next.some((existing) => existing.name === file.name
                    && existing.size === file.size && existing.lastModified === file.lastModified)) {
                    next.push(file);
                }
            }
            const limit = input.multiple ? Number(this.$el.dataset.maxFiles) : 1;
            if (limit > 0 && next.length > limit) {
                this.message = `You can select up to ${limit} file${limit === 1 ? '' : 's'}. No files were added. Remove a file or choose fewer files.`;
            } else {
                selected = next;
                this.message = '';
            }
            this.sync();
        },

        remove(event) {
            const index = Number(event.currentTarget.dataset.index);
            selected.splice(index, 1);
            this.message = '';
            this.sync();
            this.$nextTick(() => input.focus());
        },

        sync() {
            const transfer = new DataTransfer();
            for (const file of selected) transfer.items.add(file);
            input.files = transfer.files;
            this.files = selected.map((file, index) => ({
                index,
                name: file.name,
                removeLabel: `Remove ${file.name}`,
            }));
        },

        destroy() {
            form?.removeEventListener('reset', onReset);
        },
    };
}
